import { Pill } from '@HoudiniUI/Pill';
import { css } from 'aphrodite';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { BasicPage } from '../../containers/BasicPage';
import { getVisibleSettingsCards, SettingsSectionType } from '../../models/setting';
import { SettingsCard, SettingsCardGrid, SettingsCardHue } from '../SettingsCard';
import { SettingIcons } from './settingIcons';
import { styleSheet } from './styles';

const Sections: { hue: SettingsCardHue; title: string; type: SettingsSectionType }[] = [
	{ hue: 'orange', title: 'Gamification', type: SettingsSectionType.Gamification },
	{ hue: 'purple', title: 'Coaching & AI', type: SettingsSectionType.CoachingAndAi },
	{ hue: 'teal', title: 'Reporting', type: SettingsSectionType.Reporting },
	{ hue: 'blue', title: 'Calling setup', type: SettingsSectionType.CallingSetup },
	{ hue: 'gray', title: 'Account', type: SettingsSectionType.Account },
	{ hue: 'gray', title: 'Your account', type: SettingsSectionType.YourAccount },
	{ hue: 'blue', title: 'Calling', type: SettingsSectionType.Calling },
	{ hue: 'purple', title: 'Coaching', type: SettingsSectionType.Coaching },
	{ hue: 'orange', title: 'Rewards', type: SettingsSectionType.Rewards },
];

export const SettingsHome = () => {
	const { account } = useUserSession();
	const isAdmin = !!account?.isAdmin;
	const cards = getVisibleSettingsCards({
		achievementsEnabled: !!account?.features?.aida?.achievementsEnabled,
		isAdmin,
		isLevitateSalesCoffeeAccount: !!account?.isLevitateSalesCoffeeAccount,
	});
	const sections = Sections.map(section => ({
		...section,
		cards: cards.filter(card => card.section === section.type),
	})).filter(section => section.cards.length > 0);

	return (
		<BasicPage
			appearance='light'
			title='Settings'
			subtitle={isAdmin ? 'Admin settings for your Coffee account' : 'Your Coffee settings'}
		>
			<div className={css(styleSheet.sections)}>
				{sections.map(section => (
					<section className={css(styleSheet.section)} key={section.type}>
						<div className={css(styleSheet.sectionHeader)}>
							<h2 className={css(styleSheet.sectionTitle)}>{section.title}</h2>
							{section.cards.every(card => !!card.href) ? (
								<Pill variant='label' color='gray' label='Opens in Levitate' />
							) : null}
						</div>
						<SettingsCardGrid>
							{section.cards.map(card => (
								<SettingsCard
									description={card.description}
									href={card.href}
									hue={section.hue}
									key={card.settingType}
									renderIcon={className => SettingIcons[card.settingType]?.(className)}
									title={card.text}
									to={card.to || `/settings/${card.settingType}`}
								/>
							))}
						</SettingsCardGrid>
					</section>
				))}
			</div>
		</BasicPage>
	);
};
